// helpDeskReducer.js
import {
	SET_MESSAGES,
	ADD_MESSAGE,
	DELETE_MESSAGE,
	OPEN_MODAL,
	CLOSE_MODAL,
	UPDATE_MESSAGE_TYPE,
	FETCH_DIVISION_OPTIONS,
	UPDATE_DIVISION,
	UPDATE_DIVISION_MESSAGE,
	SUBMIT_MESSAGE,
	OPEN_DELETE_POPUP,
	CLOSE_DELETE_POPUP,
	OPEN_DELETE_SUCCESS_POPUP,
	OPEN_SUBMIT_SUCCESS_POPUP,
	CLOSE_SUBMIT_SUCCESS_POPUP,
	CLOSE_DELETE_SUCCESS_POPUP,
	GET_DIVISION,
	SET_DIVISION,
	DELETE_STATUS_MESSAGE,
	CREATEMSG_STATUS_MESSAGE,
	EDIT_TRUE,
	EDIT_FALSE,
	EDIT_MESSAGE_REQUEST,
	EDIT_MESSAGE_SUCCESS,
	EDIT_MESSAGE_FAILURE,
	SET_SERIAL_NUMBER_TO_EDIT,
	CLEAR_SERIAL_NUMBER_TO_EDIT,
	GET_ARCHIVE_MESSAGES_REQUEST,
	GET_ARCHIVE_MESSAGES_SUCCESS,
	GET_ARCHIVE_MESSAGES_FAILURE,
	SET_ARCHIVE_MESSAGES,
	CLEAR_ARCHIVE_MESSAGES,
	ACTIVATE_MESSAGE_REQUEST,
	ACTIVATE_MESSAGE_SUCCESS,
	ACTIVATE_MESSAGE_FAILURE,
	CLEAR_ACTIVATION_RESPONSE,
	ACTIVATE_POPUP_STATUS_MSG,
	OPEN_ACTIVATE_SUCCESS_POPUP,
	CLOSE_ACTIVATE_SUCCESS_POPUP,
	FETCH_MESSAGE_TYPES_REQUEST,
	FETCH_MESSAGE_TYPES_SUCCESS,
	FETCH_MESSAGE_TYPES_FAILURE,
	SET_PAGENO_HELPDESK,
	SET_PAGESIZE_HELPDESK,
	SET_TOTALPAGES_HELPDESK,
	SET_TOTALRECORDS_HELPDESK,
} from "./helpDeskActions";

const initialState = {
	messages: [],
	archiveMessages: [],
	messageType: "Emergency",
	// division: "",
	divisionMessage: "",
	divisionOptions: [],
	options: ["Emergency", "Global", "Division"],
	showModal: false, //for create new mwssage pop-up
	showDeletePopup: false, //for delete pop-up
	// showDeleteSuccessPopup: false, //delete success pop-up
	showSubmitSuccessPopup: false, //submit success pop-up
	messageToDelete: null,
	division: [],
	deletePopUpStatusMessage: "",
	createNewMessagePopUpStatusMessage: "",
	showSuccessPopup: false, //delete success pop-up
	isEditing: false,
	message: {},
	activationResponse: null,
	popupStatusMsg: "",
	isActivateSuccessPopupOpen: false,
	loading: false,
	error: null,
	pageNoHelpDesk: 1,
	pageSizeHelpDesk: 10,
	totalPagesHelpDesk: 0,
	totalRecordsHelpDesk: 0,
};

const helpDeskReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_MESSAGES:
			return {
				...state,
				messages: action.payload,
			};
		case ADD_MESSAGE:
			return {
				...state,
				// messages: [...state.messages, action.payload],
				messages: action.payload,
			};
		case DELETE_MESSAGE:
			return {
				...state,
				serialNumber: action.payload,
			};

		case UPDATE_MESSAGE_TYPE:
			return {
				...state,
				messageType: action.payload,
			};
		case FETCH_DIVISION_OPTIONS:
			return {
				...state,
				divisionOptions: action.payload,
			};
		case UPDATE_DIVISION:
			return {
				...state,
				division: action.payload,
			};
		case UPDATE_DIVISION_MESSAGE:
			return {
				...state,
				divisionMessage: action.payload,
			};
		case SUBMIT_MESSAGE:
			// Handle message submission here
			return state;
		case OPEN_DELETE_POPUP:
			return {
				...state,
				showDeletePopup: true,
				messageToDelete: action.payload,
			};
		case CLOSE_DELETE_POPUP:
			return {
				...state,
				showDeletePopup: false,
				messageToDelete: null,
			};
		case OPEN_DELETE_SUCCESS_POPUP:
			return {
				...state,
				showSuccessPopup: true,
			};
		case CLOSE_DELETE_SUCCESS_POPUP:
			return {
				...state,
				showSuccessPopup: false,
			};

		case OPEN_MODAL:
			return {
				...state,
				showModal: true,
			};
		case CLOSE_MODAL:
			return {
				...state,
				showModal: false,
			};
		case OPEN_SUBMIT_SUCCESS_POPUP:
			return {
				...state,
				showSubmitSuccessPopup: true,
			};
		case CLOSE_SUBMIT_SUCCESS_POPUP:
			return {
				...state,
				showSubmitSuccessPopup: false,
			};
		case GET_DIVISION:
			return Object.assign({}, state, {
				division: action.value,
			});
		case SET_DIVISION:
			return Object.assign({}, state, {
				division: action.value,
			});

		case DELETE_STATUS_MESSAGE:
			return {
				...state,
				deletePopUpStatusMessage: action.payload,
			};

		case CREATEMSG_STATUS_MESSAGE:
			return {
				...state,
				createNewMessagePopUpStatusMessage: action.payload,
			};

		case EDIT_TRUE:
			return {
				...state,
				isEditing: true,
			};
		case EDIT_FALSE:
			return {
				...state,
				isEditing: false,
			};
		case EDIT_MESSAGE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case EDIT_MESSAGE_SUCCESS:
			return {
				...state,
				loading: false,
				message: action.payload,
			};
		case EDIT_MESSAGE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case SET_SERIAL_NUMBER_TO_EDIT:
			return {
				...state,
				serialNumberToEdit: action.payload,
			};
		case CLEAR_SERIAL_NUMBER_TO_EDIT:
			return {
				...state,
				serialNumberToEdit: null,
			};
		case GET_ARCHIVE_MESSAGES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case GET_ARCHIVE_MESSAGES_SUCCESS:
			return {
				...state,
				loading: false,
				archiveMessages: action.payload.archiveMessages,
				pageNumber: action.payload.pageNumber,
				pageSize: action.payload.pageSize,
				sortOrder: action.payload.sortOrder,
			};
		case GET_ARCHIVE_MESSAGES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case SET_ARCHIVE_MESSAGES:
			return {
				...state,
				archiveMessages: action.payload,
			};
		case CLEAR_ARCHIVE_MESSAGES:
			return {
				...state,
				archiveMessages: [],
			};
		case ACTIVATE_MESSAGE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case ACTIVATE_MESSAGE_SUCCESS:
			return {
				...state,
				loading: false,
				activationResponse: action.payload,
			};
		case ACTIVATE_MESSAGE_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case CLEAR_ACTIVATION_RESPONSE:
			return {
				...state,
				activationResponse: null,
			};
		case ACTIVATE_POPUP_STATUS_MSG:
			return {
				...state,
				popupStatusMsg: action.payload,
			};
		case OPEN_ACTIVATE_SUCCESS_POPUP:
			return {
				...state,
				isActivateSuccessPopupOpen: true,
			};
		case CLOSE_ACTIVATE_SUCCESS_POPUP:
			return {
				...state,
				isActivateSuccessPopupOpen: false,
			};
		case FETCH_MESSAGE_TYPES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case FETCH_MESSAGE_TYPES_SUCCESS:
			return {
				...state,
				loading: false,
				options: action.payload,
			};
		case FETCH_MESSAGE_TYPES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case SET_PAGENO_HELPDESK:
			return { ...state, pageNoHelpDesk: action.payload };
		case SET_PAGESIZE_HELPDESK:
			return { ...state, pageSizeHelpDesk: action.payload };
		case SET_TOTALPAGES_HELPDESK:
			return { ...state, totalPagesHelpDesk: action.payload };
		case SET_TOTALRECORDS_HELPDESK:
			return { ...state, totalRecordsHelpDesk: action.payload };
		default:
			return state;
	}
};

export default helpDeskReducer;
